
import { Options, Vue } from 'vue-class-component'
import { store } from '@/state';
import TopicForm from '@/components/TopicForm.vue';
import { reactive } from 'vue';
import ClosablePanel from '@/components/ClosablePanel.vue';
import { Topic } from '@/types';
import { generateTitle } from '@/utils';
import { twitch } from '@/twitch-instance';
import TopicEntry from '@/components/TopicEntry.vue';
import HistoryList from '@/components/HistoryList.vue';
import OptionsVue from '@/components/Options.vue';
import ScrollingContent from '@/components/ScrollingContent.vue';
import Modal from '@/components/Modal.vue';

// TODO extract handler / instance

function wait (ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const hashParams = new URLSearchParams(location.hash?.replace('#', ''));

@Options({
  components: {
    Modal,
    TopicForm,
    ClosablePanel,
    TopicEntry,
    HistoryList,
    Options: OptionsVue,
    ScrollingContent
  }
})
export default class App extends Vue {
  state = store.state;

  startAnimate = false;

  authRedirectMode = hashParams.has('id_token');

  loggedIn = false;
  userName = '';
  showHistory = false;
  showOptions = false;
  showNewForm = false;
  formForTopic?: Topic|null = reactive<any>(null);

  async mounted () {
    if (this.authRedirectMode) {
      twitch.checkTokens();
    }

    const loginResult = await twitch.loginExists();

    console.info({ loginResult });
    if (loginResult) {
      this.loggedIn = !!loginResult?.preferred_username;
      if (!this.loggedIn) {
        this.loggedIn = false;
        twitch.resetAuth();
        return;
      }

      this.userName = loginResult.preferred_username;
    } else {
      this.loggedIn = false;
    }

    store.setLoggedIn(this.loggedIn);
  }

  onAddNew (topic: Topic) {
    store.addTopic(topic);

    this.showNewForm = false;
  }

  deleteTopic (topic: Topic) {
    if (window.confirm('Delete this topic?')) {
      store.deleteTopic(topic);
    }
  }

  showEditForm (topic: Topic) {
    console.info({ topic });
    this.formForTopic = topic;
  }

  editTopic (topic: Topic) {
    console.info({ topic });
    store.editTopic(topic);
    this.formForTopic = null;
  }

  increaseCounter (topic: Topic) {
    topic.currentCounter++;
    store.editTopic(topic);

    // push new title to twitch
    console.info('Push title to Twitch: ', { ...topic });
  }

  async setupTwitch (topic: Topic) {
    store.addHistoryEntry({
      task: `Applied ${topic.title}: ${topic.currentCounter}`,
      lastTitle: generateTitle(topic),
      topicId: topic.id ?? -1,
      lastCounter: topic.currentCounter
    });

    await twitch.applyTopicToTwitch(topic);

    for (const command of topic.commands) {
      await twitch.writeToChat(command);
      await wait(1000);
    }
  }

  async getToken () {
    const { userId, userName } = await twitch.login();
    if (userId) {
      this.loggedIn = true;
      this.userName = userName;
    }
  }

  logout () {
    twitch.resetAuth();
    this.loggedIn = false;
    this.userName = '';
  }

  unArchiveTopic (topic: Topic) {
    topic.archived = false;
    store.editTopic(topic);
  }

  get currentTopics () {
    return this.state.topics.filter(t => !t.archived);
  }

  get archivedTopics () {
    return this.state.topics.filter(t => t.archived);
  }
}
